export const RouteAnalysis = {
  GET_ROUTE_SUMMARY: "GET_ROUTE_SUMMARY",
  GET_ROUTE_SUMMARY_SUCCESS: "GET_ROUTE_SUMMARY_SUCCESS",
  GET_ROUTE_SUMMARY_FAILURE: "GET_ROUTE_SUMMARY_FAILURE",
  CLEAR_ROUTE_SUMMARY: "CLEAR_ROUTE_SUMMARY",

  // download pdf report
  DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT: "DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT",
  DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_SUCCESS:
    "DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_SUCCESS",
  DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_FAILURE:
    "DOWNLOAD_ROUTE_ANALYSIS_PDF_REPORT_FAILURE",
};
